import {ColumnStore} from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";
import {
  columnAvatarConfig, columnAvatarString, EntityMainNameDefault, getCustomGroupRenderer, swivuGridSorterFn
} from "../../other/utils/utils.jsx";
import SwivuSortColumn from "./SwivuSortColumn.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { EDITOR_KEYS } from "../../other/constants/EditorKeys.jsx";

export default class AssignToColumn extends SwivuSortColumn {
  static get fields() {
    return [
      { name: "swivuListTitle" },
      { name: "swivuListSearchKey", readOnly: true, defaultValue: "name" },
    ]
  }

  static get $name() {
    return "AssignToColumn";
  }

  static get type() {
    return WIDGET_KEYS.assignToColumn;
  }

  static get defaults() {
    return {
      text: "Assigned To",
      field: "assignedBoardUserValues",
      maxWidth: "40em",
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      flex: 1,
      filterType: "_swivu_settings",
      groupRenderer(e) {
        return getCustomGroupRenderer(e);
      },
      editor: false,
      tooltipRenderer: columnAvatarConfig.tooltipRenderer
    }
  }

  renderer({ value, record, grid }) {
    if (!record.isGroupHeader && this.project && value) {
      return record.assignedBoardUsers.length ? record.assignedBoardUsers.map((boardUserId) => {
        const boardUserRecord = this.project.boardUsersStore.getById(boardUserId);
        return columnAvatarConfig.columnAvatarRenderer({
          image: boardUserRecord.profileImageURL,
          name: boardUserRecord.name,
          size: grid.rowHeight,
          showName: false
        });
      }) : EntityMainNameDefault()
    }
  }

  onLoad(project, { editorHandler }) {
    this.project = project;
    this.editorHandler = editorHandler;
  }

  get canMultiSelectSwivuList() {
    return true
  }

  get swivuListItems() {
    return this.project.getCrudStore(STORE_KEYS.boardUserStore).query(() => true, true).sort(swivuGridSorterFn.bind({ field: "name" }));
  }

  getSwivuListItemDisplayValue(record) {
    return columnAvatarString(record.name, record.profileImageURL);
  }

  getSelectedSwivuListItem(record) {
    return record.assignedBoardUsers;
  }

  onSwivuListSelectionChange(record, assignedBoardUsers) {
    record.assignedBoardUsers = assignedBoardUsers.map(item => item.id);
  }

  onSwivuManageList() {
    const newRecord = this.project.boardUsersStore.createRecord();
    this.editorHandler.openEditor(EDITOR_KEYS.userEditor, newRecord, {
      user: newRecord
    })
  }
}

ColumnStore.registerColumnType(AssignToColumn);
